import useSWR from 'swr';
import { getRequest, postRequest, patchRequest, deleteRequest, putRequest } from '../utils/request';

export const getAppointments = async (queryParams) => getRequest(`/appointment`, queryParams);
export const GetAppointments = queryParams => useSWR(() => !queryParams?.revoke ? [`/appointment`, queryParams] : null, getRequest)

export const getAppointmentsByDoctor = async (queryParams) => getRequest(`/appointment/doctor`, queryParams);
export const getAppointmentsByTherapist = async (queryParams) => getRequest(`/appointment/therapist`, queryParams);

export const getAppointmentsByPatient = async (queryParams) => getRequest(`/appointment/patient`, queryParams);

export const getAppointmentById = async (id) => getRequest(`/appointment/${id}`);
export const GetAppointmentById = id => useSWR(() => id ? `/appointment/${id}` : null, getRequest)

export const postAppointment = async (data) => postRequest(`/appointment`, data);

export const patchAppointment = async (id, data) => patchRequest(`/appointment/${id}`, data);
export const updateStatusAppointment = async (id, data) => putRequest(`/appointment/${id}/update-status`, data);

export const deleteAppointment = async (id) => deleteRequest(`/appointment/${id}`);